<template>
  <div class="page">
    <div class="main">
      <div class="sta-list" v-for="(item, index) in stadiumList" :key="item.id">
         <div class="sta-left">
          <img :src="item.conver" alt="">
         </div>
         <div class="sta-right">
          <div class="title">{{item.name}}</div>
          <div class="info">{{item.description}}</div>
          <div class="address">地址：{{item.addr}}</div>
<!--          <div class="tel">电话：{{item.tel}}</div>-->
          <div class="match-title">举办赛事：</div>
          <div class="sta-match">
            <div class="sta-match-item" v-for="(p, pIndex) in item.programs" :key="pIndex">
              <img :src="require('@daoba-match/assets/darkSportsLogo/'+ p.id +'.png')" alt="">
              <div class="name">{{p.name}}</div>
            </div>
          </div>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  components: {
  },
  data () {
    return {
      stadiumList: []
    }
  },
  mounted () {
    this.matchFieldList()
  },
  methods: {
    matchFieldList () {
      this.$api.district.matchFieldList().then(res => {
        if (res.status === 0) {
          this.stadiumList = res.data
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
  .page{
    width: 100%;
    min-height: 580px;
    background: url('https://static.daoba.com/jlpsport/stadium_bg.jpg') no-repeat top center;
    background-size: 100% 540px;
    border: 1px solid transparent;
    .main{
      width: 1200px;
      margin: 0 auto;
      min-height: 700px;
      margin-top: 130px;
      background-color: #ffffff;
      color: #333333;
      padding: 40px;
      .sta-list{
        width: 100%;
        margin-bottom: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .sta-left {
          img {
            width: 540px;
            height: 360px;
          }
        }
        .sta-right{
          padding-left: 40px;
          box-sizing: border-box;
          font-size: 14px;
          .title{
            width: 100%;
            font-weight: bold;
            font-size: 24px;
          }
          .info{
            margin-top: 15px;
            height: 170px;
          }
          .addr{
             margin-bottom: 20px;
          }
          .tel{
             margin-bottom: 10px;
          }
          .match-title{

            font-weight: bold;
          }
          .sta-match{
            width: 540px;
            display: flex;
            justify-content: flex-start;
            // overflow: auto;
            // overflow-y: hidden;
            padding-top: 10px;
            padding-bottom: 10px;
            text-align: center;
            .sta-match-item{
              margin-right: 20px;
            }
            img{
              width: 60px;
              height: 60px;
            }
            .name{

            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/district/views/stadium/Home.vue